import React, { forwardRef } from "react";
import styled, { css } from "styled-components";
import Container from "./Container";
import { HtmlContent } from "./Content";

const SectionStyles = styled.section`
  ${({ ...props }) => {
    let bg = "#fff";

    if (props.$grey) {
      bg = props.theme.colors.lightGrey;
    } else if (props.$lightBlue) {
      bg = props.theme.colors.lightPrimary;
    }
    return css`
      padding: 24px 0;
      background: ${bg};

      &.section--grey + .section--grey {
        padding-top: 0;
      }

      &.section--white + .section--white {
        padding-top: 0;
      }

      @media (min-width: ${props.theme.breakpoints.lg}) {
        padding: 48px 0;
      }
    `;
  }};
`;

const HeadingStyles = styled.h2`
  ${({ ...props }) => {
    return css`
      margin-bottom: 24px;

      @media (min-width: ${props.theme.breakpoints.lg}) {
        text-align: center;
        margin-bottom: 48px;
      }
    `;
  }};
`;

const SubHeadingStyles = styled.p`
  ${({ ...props }) => {
    return css`
      margin-bottom: 24px;
      margin-top: -24px;
      font-size: 1.125rem;
      line-height: 28px;

      @media (min-width: ${props.theme.breakpoints.lg}) {
        text-align: center;
        margin-bottom: 48px;
        margin-top: -48px;
      }
    `;
  }};
`;

const Section = (
  { children, heading, grey, lightBlue, id, subHeading, className, ...rest },
  ref
) => {
  let backgroundClass = "white";

  if (grey) {
    backgroundClass = "grey";
  } else if (lightBlue) {
    backgroundClass = "light-blue";
  }
  return (
    <SectionStyles
      $grey={grey}
      $lightBlue={lightBlue}
      id={id}
      className={`section--${backgroundClass} ${className}`}
      ref={ref}
      {...rest}
    >
      {heading && (
        <Container>
          <HeadingStyles>
            <HtmlContent htmlString={heading} />
          </HeadingStyles>
          {subHeading && (
            <SubHeadingStyles className="lead">
              <HtmlContent htmlString={subHeading} />
            </SubHeadingStyles>
          )}
        </Container>
      )}
      {children}
    </SectionStyles>
  );
};

export default forwardRef(Section);
